// Function to get the fundraiser value from cookie or localStorage
function getFundraiserValue() {
  let fundraiser = getCookie('fundraiser');
  if (!fundraiser) {
    fundraiser = localStorage.getItem('fundraiser');
  }
  return fundraiser;
}

// Function to set the fundraiser value in cookie and localStorage
function setFundraiserValue(value) {
  setCookie('fundraiser', value, 2); // Set cookie for 2 days
  localStorage.setItem('fundraiser', value);
}

// Function to check the URL for the "fundraiser" parameter and set a cookie/localStorage
function checkFundraiserURL() {
  const urlParams = new URLSearchParams(window.location.search);
  const fundraiser = urlParams.get('fundraiser');
  if (fundraiser) {
    setFundraiserValue(fundraiser);
    console.log('Fundraiser value set:', fundraiser);
  }
}

// Function to enforce or remove the fundraiser note requirement
function updateFundraiserNoteRequirement() {
  const fundraiser = getFundraiserValue();
  if (fundraiser) {
    console.log('Fundraiser value found:', fundraiser);
    enforceFundraiserNote(); // Enforce the note requirement
  } else {
    console.log('No fundraiser value found.');
    removeFundraiserNoteRequirement(); // Remove the note requirement
  }
}

// Function to enforce the fundraiser note requirement
function enforceFundraiserNote() {
  console.log('Enforcing fundraiser note requirement.');

  waitForElement('#CartDrawer-FundraiserNote', function (noteField) {
    console.log('Note field found:', noteField);

    waitForElement('label[for="CartDrawer-FundraiserNote"]', function (noteLabel) {
      console.log('Note label found:', noteLabel);

      // Avoid redundant updates
      if (!noteField.classList.contains('fundraiser-required')) {
        noteLabel.innerHTML = "Supporting a fundraiser? Tell us the individual you're supporting (Required)";
        noteField.required = true;
        noteField.classList.add('fundraiser-required');

        // Show the fundraiser note element
        waitForElement('#Fundraiser-CartDrawer', function (fundraiserElement) {
          console.log('Fundraiser element found:', fundraiserElement);

          // Use class to control visibility
          fundraiserElement.classList.add('fundraiser-visible');
          fundraiserElement.style.display = 'block'; // Make the field visible
        });

        // Set the note field when the fundraiser value is found
        setNoteField();
      }
    });
  });
}

// Function to remove the fundraiser note requirement
function removeFundraiserNoteRequirement() {
  console.log('Removing fundraiser note requirement.');

  waitForElement('#CartDrawer-FundraiserNote', function (noteField) {
    waitForElement('label[for="CartDrawer-FundraiserNote"]', function (noteLabel) {
      if (noteField.classList.contains('fundraiser-required')) {
        noteLabel.innerHTML = "Supporting a fundraiser? Tell us the individual you're supporting (Optional)";
        noteField.required = false;
        noteField.classList.remove('fundraiser-required');

        // Hide the fundraiser note element
        waitForElement('#Fundraiser-CartDrawer', function (fundraiserElement) {
          fundraiserElement.classList.remove('fundraiser-visible');
          fundraiserElement.style.display = 'none'; // Hide the field

          // Hide any existing error messages
          hideError();
        });
      }
    });
  });
}

// Debounce function to limit the rate at which a function can fire
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

// Function to set the note field
function setNoteField() {
  const noteFieldSelector = '#CartDrawer-FundraiserNote';
  waitForElement(noteFieldSelector, function (noteField) {
    if (!noteField.hasAttribute('data-listeners-added')) {
      noteField.addEventListener('input', debounce(function () {
        saveFundraiserNote();
        hideError(); // Hide error when user starts typing
      }, 300));
      noteField.addEventListener('blur', saveFundraiserNote);
      noteField.setAttribute('data-listeners-added', 'true');
      console.log('Listeners added to note field');
    }

    waitForElement('#CartDrawer-Checkout', function (checkoutButton) {
      if (!checkoutButton.hasAttribute('data-listeners-added')) {
        checkoutButton.addEventListener('click', function (event) {
          const noteValue = noteField.value;
          if (!noteValue.trim()) {
            event.preventDefault();
            showError("Please specify the individual you're supporting before checking out.");
            // Optionally, scroll to the note field
            noteField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            noteField.focus();
          } else {
            hideError();
          }
        });
        checkoutButton.setAttribute('data-listeners-added', 'true');
        console.log('Listener added to checkout button');
      }
    });
  });
}

// Function to save the fundraiser note to cart attributes
async function saveFundraiserNote() {
  const noteField = document.querySelector('#CartDrawer-FundraiserNote');
  const noteValue = noteField.value;
  if (noteValue.trim()) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            'fundraiser-note': noteValue,
          },
        }),
      });
      const data = await response.json();
      console.log('Fundraiser note saved:', data);
    } catch (error) {
      console.error('Error saving fundraiser note:', error);
    }
  }
}

// Function to show an inline error message below the note field within #Fundraiser-CartDrawer
function showError(message) {
  waitForElement('#Fundraiser-CartDrawer', function (fundraiserContainer) {
    let errorElement = document.querySelector('#FundraiserNoteError');
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.id = 'FundraiserNoteError';
      errorElement.style.color = 'red';
      errorElement.style.marginTop = '5px';
      errorElement.style.fontSize = '14px';
      errorElement.setAttribute('role', 'alert');
      // Insert the error message as a sibling after the fundraiser container
      fundraiserContainer.parentNode.insertBefore(errorElement, fundraiserContainer.nextSibling);
    }
    errorElement.textContent = message;
  });
}

// Function to hide the inline error message
function hideError() {
  const errorElement = document.querySelector('#FundraiserNoteError');
  if (errorElement) {
    errorElement.textContent = '';
  }
}

// Function to listen for cart updates using the theme's publish/subscribe system
function observeCartUpdates() {
  // Ensure that PUB_SUB_EVENTS and subscribe are available
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
    // Subscribe to cart updates
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      console.log('Cart updated event detected via PUB_SUB_EVENTS.');
      updateFundraiserNoteRequirement();
    });
  } else {
    console.error('PUB_SUB_EVENTS or subscribe function is not available.');
    // As a fallback, we can use MutationObserver or setInterval polling (not recommended)
  }
}

// Function to observe when the cart drawer opens
function observeCartDrawerOpen() {
  waitForElement('#CartDrawer_Wrapper', function(cartDrawer) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          // Check if the cart drawer is open
          if (CartDrawer_Wrapper.classList.contains('active')) {
            console.log('Cart drawer opened.');
            updateFundraiserNoteRequirement();
          }
        }
      });
    });
    observer.observe(cartDrawer, {
      attributes: true, // Listen for attribute changes
      attributeFilter: ['class'], // Only listen for class attribute changes
    });
  });
}

// Function to wait for an element to be present in the DOM
function waitForElement(selector, callback) {
  const element = document.querySelector(selector);
  if (element) {
    callback(element);
  } else {
    const observer = new MutationObserver(function (mutations, me) {
      const element = document.querySelector(selector);
      if (element) {
        me.disconnect(); // Stop observing
        callback(element);
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

// Function to get a cookie by name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// Function to set a cookie
function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Cookie valid for 'days' number of days
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

// Run the initial check when the page loads
document.addEventListener('DOMContentLoaded', () => {
  checkFundraiserURL(); // Check for the fundraiser in the URL
  // Remove initial call to updateFundraiserNoteRequirement()
  observeCartUpdates(); // Observe cart updates using the theme's event system
  observeCartDrawerOpen(); // Observe when the cart drawer opens
});
